import type { State, HelpUrlMapping } from './types';

export const initialState: State = {
    isLoading: false,
    conversation: null,
    searchAll: false,
    pipeline: '',
    isTesting: false,
    feedbackCollectorConfig: {
        isVisible: false,
        messageId: undefined,
    },
    isAuthPromptVisible: false,
    providerAuthStatus: [],
    activeTimer: null,
};

export const JSM_HELP_CENTER_URL = '/servicedesk/customer';

// Admin fallback message mapping hardcoded for alpha
export const helpUrlMapping: HelpUrlMapping = {
    [`a436116f-02ce-4520-8fbb-7301462a1674`]: `go/help-legacy`, // hello
};

export const ASSISTANT_USER_TYPE = 'assistant';

export const BOT_USER_TYPE = 'bot';

export const HELP_SEEKER_USER_TYPE = 'helpseeker';
